import React from 'react'

const Map = ({ latitude, longitude }) => {
  if (!latitude || !longitude) return null
  return (
    <section className='component-map mx-auto max-w-screen-xl p-6'>
      <div id='map' className='relative rounded border' style={{ paddingBottom: '56.25%' }}>
        <iframe
          className='absolute inset-0'
          width='100%'
          height='100%'
          title='Google Map of Venue'
          src={`https://www.google.com/maps/embed/v1/place?key=${process.env.GATSBY_GOOGLE_API_KEY}&q=${latitude},${longitude}`}
          allowFullScreen
        />
      </div>
    </section>
  )
}

export default Map
